export const SUIT_VALUES = {'h': 'hearth', 's': 'spades', 'd': 'diamond', 'c': 'club', 'A': 'a'};

export const GAME_STATUS = [
    {value: "WAITING", label: "waiting"},
    {value: "BUSY", label: "busy"},
];

export const GAME_CONVENTIONS = [
    [
        {
            value: 2,
            label: "all_combinations",
            type: 'radio',
        },
        {
            value: 3,
            label: "not_4&100",
            type: 'radio',
        },
        {
            value: 1,
            label: "only_belote",
            type: 'radio',
        },
        {
            value: 40,
            label: "only_tierce",
            type: 'radio',
        },
    ], [
        {
            value: 10,
            label: "without_boy",
            type: 'checkbox',
            hasCheckbox: true
        },
        {
            value: 50,
            label: "private_game",
            type: 'checkbox',
            hasCheckbox: true
        },
        {
            value: "gift",
            label: "is_bonus",
            type: 'checkbox',
            hasCheckbox: true
        }
        ]
];

export const COMBINATION_ANNOUNCE_BUTTONS = {
    1: [],
    2: ['fours', '100', '50', 'tierce'],
    3: ['50', 'tierce'],
    40: ['tierce'],
}

export const TABS = ["Cash", "Tournament"];

export const RAKE_RACE_TABS = ["RakeRaceCurrent", "RakeRacePrevious", "RakeRaceInformation"];

export const ROOM_TABLE_TITLES = [
    "table_room_id",
    "table_room_player",
    "table_room_score",
    "table_room_opponent",
    "table_room_bet",
    "table_room_till",
    "table_room_step_time",
    "table_room_type",
    ""
];

export const TOURNAMENT_TABLE_TITLES = [
    "table_tournament_name",
    "table_tournament_buy_in",
    "table_tournament_till",
    "table_tournament_type",
    "table_tournament_start",
    "table_tournament_prize",
    ""
]

export const RAKE_RACE_TABLE_TITLES = [
    "table_rake_place",
    "table_rake_user_id",
    "table_rake_game_count",
    "table_rake_points",
    "table_rake_prize",
]

export const HISTORY_TABLE_TITLES = [
    "table_history_game_id",
    "table_history_type",
    "table_history_opponent",
    "table_history_bet",
    "table_history_till",
    "table_history_conventions",
    "table_history_step_time",
    "table_history_started",
];

export const COMBINATION_MODAL_BUTTONS = [
    {name: 'tierce', length: 3, counts: [1, 2, 3], cId: 1},
    {name: '50', length: 4, counts: [1, 2], cId: 2},
    {name: '100', length: 5, counts: [1], cId: 3},
    {name: 'fours', length: 4, counts: [1, 2], cId: 4},
]

export const AVATARS = [
    "/images/avatar/avatar1.png",
    "/images/avatar/avatar2.png",
    "/images/avatar/avatar3.png",
    "/images/avatar/avatar4.png",
    "/images/avatar/avatar5.png",
    "/images/avatar/avatar6.png",
    "/images/avatar/avatar7.png",
    "/images/avatar/avatar8.png",
    "/images/avatar/avatar9.png",
    "/images/avatar/avatar10.png",
    "/images/avatar/avatar11.png",
    "/images/avatar/avatar12.png",
    "/images/avatar/avatar13.png",
    "/images/avatar/avatar14.png",
    "/images/avatar/avatar15.png"
]

export const CARD_FRONT = [
    "/images/cards/front/frontV1.png",
    "/images/cards/front/frontV2.png",
    "/images/cards/front/frontV3.png",
    "/images/cards/front/frontV4.png",
]

export const CARD_BACK = [
    "/images/cards/back/backV1.png",
    "/images/cards/back/backV2.png",
    "/images/cards/back/backV3.png",
    "/images/cards/back/backV4.png",
]

export const BOARD_STYLE = [
    "green",
    "blue",
    "red",
    "purple"
]

export const HISTORY_TYPE = [
    {value: "all", label: "all"},
    {value: "cash", label: "cash"},
    {value: "tournament", label: "tournament"},
];

export const HISTORY_RESULT = [
    {value: "all", label: "all"},
    {value: "win", label: "win"},
    {value: "lose", label: "lose"},
];

export const SLIDER_CONFIG = {
    playOnInit: true,
    stopOnInteraction: false,
    delay: 3000
}
export const PLACE_COLORS = {
    1: 'gold',
    2: 'silver',
    3: 'bronze',
}

export const HISTORY_FILTER_INITIAL_STATE = {
    minBet: '',
    maxBet: '',
    result: null,
    till: null,
    type: null
}

export const TABLE_INDICATOR_COLORS = {
    'WAITING': 'green',
    'PROGRESS': 'red',
    'REQUEST_TO_JOIN': 'orange',
    'FINISHED': 'red',
    'CANCELED': 'red',
}
export const MONTHS = {
    "am": {
        "Jan":"Հունվ",
        "Feb":"Փետ",
        "Mar":"Մարտ",
        "Apr":"Ապր",
        "May":"Մայիս",
        "Jun":"Հունիս",
        "Jul":"Հուլիս",
        "Aug":"Օգոստ",
        "Sep":"Սեպ",
        "Oct":"Հոկ",
        "Nov":"Նոյ",
        "Dec":"Դեկ",
    },
    "ru": {
        "Jan":"Янв",
        "Feb":"Фев",
        "Mar":"Мар",
        "Apr":"Апр",
        "May":"Май",
        "Jun":"Июн",
        "Jul":"Июл",
        "Aug":"Авг",
        "Sep":"Сен",
        "Oct":"Окт",
        "Nov":"Ноя",
        "Dec":"Дек",
    },
    "en": {
        "Jan":"Jan",
        "Feb":"Feb",
        "Mar":"Mar",
        "Apr":"Apr",
        "May":"May",
        "Jun":"Jun",
        "Jul":"Jul",
        "Aug":"Aug",
        "Sep":"Sep",
        "Oct":"Oct",
        "Nov":"Nov",
        "Dec":"Dec",
    }
}